export const role = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  LOGISTICS: 'LOGISTICS',
  ADMIN: 'ADMIN',
  TRADER: 'TRADER',
  ACCOUNT: 'ACCOUNT',
  SALES_HEAD: 'SALES_HEAD',
  SALES_EXECUTIVE: 'SALES_EXECUTIVE',
  BDE: 'BDE',
  PURCHASE_MANAGER: 'PURCHASE_MANAGER',
  // USER: 'User',
};

export const roleBasedURLS = {
  SUPER_ADMIN: '/dashboard',
  LOGISTICS: '/orders',
  ADMIN: '/dashboard',
  TRADER: '/vendors',
  ACCOUNT: '/orders',
  SALES_HEAD: '/vendors',
  SALES_EXECUTIVE: '/vendors',
  BDE: '/vendors',
  // USER: 'User',
};

// If possible add description
export const redirectionURLs = {
  SUPER_ADMIN: '/dashboard',
  LOGISTICS: '/orders',
  ADMIN: '/dashboard',
  TRADER: '/staff',
  ACCOUNT: '/invoices',
  SALES_HEAD: '/vendors',
  SALES_EXECUTIVE: '/vendors',
  BDE: '/vendors',
  // USER: 'User',
};
